<template>
  <floatingBar v-if="show" :nid="nid" :data="data" :tree-data="treeData" />
</template>

<script>
import { ref, computed } from 'vue';
import { EtrService } from '@/services';
import floatingBar from '@/components/periple/floatingBar.component.vue';

export default {
  components: {
    floatingBar,
  },
  setup() {
    const nid = ref(EtrService.nid);
    const data = ref(null);
    const treeData = ref(null);
    const show = computed(() => data.value && treeData.value);

    async function fetchData() {
      data.value = await EtrService.getPeripleNavigation();
    }

    async function fetchTree() {
      treeData.value = await EtrService.getPeripleTree();
    }

    fetchData();
    fetchTree();

    return {
      show,
      nid,
      data,
      treeData,
    };
  },
};
</script>
